import { IconChartBar as TablerIconChartBar } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconChartBar = /*#__PURE__*/ createOutlineIcon(TablerIconChartBar, 'IconChartBar');
